import React from 'react';
import { motion } from 'framer-motion';
export function StatsSection() {
  const stats = [{
    value: '+500',
    label: 'Trabajos ejecutados'
  }, {
    value: '5',
    label: 'Años de experiencia'
  }, {
    value: '+$1.000M',
    label: 'CLP facturados'
  }, {
    value: '+$200M',
    label: 'CLP en proyectos'
  }, {
    value: '0',
    label: 'Accidentes'
  }];
  return <section className="py-16 bg-navy-dark border-y border-white/5 relative overflow-hidden" data-id="element-147">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-148">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-4 text-center" data-id="element-149">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center p-4" data-id="element-150">
              <span className="text-4xl md:text-5xl font-bold text-white font-heading mb-2" data-id="element-151">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-jml-orange font-medium uppercase tracking-wider" data-id="element-152">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}